import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import { useExperiments } from '@alltrails/experiments';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import { InstallPromptType } from '../types';
import useAppsFlyerDeeplink from './useAppsFlyerDeeplink';
import useBranchDeeplink from './useBranchDeeplink';
import InstallPromptTrigger from '@alltrails/amplitude/enums/InstallPromptTrigger';

/*
  useDeeplink creates deeplinks for location and trail pages to the app, defaulting to the homepage.
*/

type UseDeepLinkParams = {
  deeplinkData?: DeeplinkData;
  customAppPath?: string;
  isOpen?: boolean;
  promptType?: InstallPromptType;
  // "displayTrigger" represents standalone install prompt triggers or SignupModal triggers
  // It gets added to the AppsFlyer OneLink for web -> app tracking in getAnalyticsParams.ts
  displayTrigger?: CarouselDisplayTrigger | InstallPromptTrigger;
};

const useDeeplink = ({ deeplinkData, customAppPath, isOpen, promptType, displayTrigger }: UseDeepLinkParams) => {
  const experiments = useExperiments();
  const isAppsFlyerEnabled = experiments['web-appsflyer-migration']?.value === 'on';

  const getAppsFlyerDeeplink = useAppsFlyerDeeplink({
    deeplinkData,
    customAppPath,
    isOpen,
    promptType,
    displayTrigger,
    isEnabled: isAppsFlyerEnabled
  });
  const branchDeeplink = useBranchDeeplink({ deeplinkData, customAppPath, promptType, displayTrigger, isEnabled: !isAppsFlyerEnabled });

  // AppsFlyer link needs to be able to be re-generated on click. Branch link is static.
  const getDeeplink = isAppsFlyerEnabled ? getAppsFlyerDeeplink : () => branchDeeplink;

  return getDeeplink;
};

export default useDeeplink;
